import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { FileText, Download } from 'lucide-react';

const TIPO_LABEL = {
  rg_cnh: 'RG / CNH',
  comprovante_endereco: 'Comprovante de endereço',
  certidao: 'Certidão casamento/nascimento',
  renda_pj: 'Comprovante de renda / PJ',
  outro: 'Documento',
  // contratos legados (assinados fora do sistema, importados)
  contrato_assinado: 'Contrato assinado',
  quadro_resumo: 'Quadro resumo',
  adendo: 'Adendo',
  anexo_contrato: 'Anexo do contrato',
  resumo_contrato: 'Resumo do contrato',
};

function fmtBytes(n) {
  if (!n) return '';
  return n < 1024 * 1024 ? `${Math.round(n / 1024)} KB` : `${(n / 1024 / 1024).toFixed(1)} MB`;
}

async function abrir(clienteId, docId, nome) {
  try {
    const res = await api.get(`/clientes/${clienteId}/documentos/${docId}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.download = nome || 'documento';
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    alert('Erro ao abrir o documento: ' + (err.response?.data?.error || err.message));
  }
}

// Documentos pessoais do cliente anexados no fluxo /reservas (RG, comprovante, certidão…).
// Passar `contratoId` (lista os deste contrato) OU `clienteId` (todos do cliente).
export default function DocumentosClienteBox({ clienteId, contratoId }) {
  const { data, isLoading } = useQuery({
    queryKey: ['docs-cliente', contratoId || clienteId, contratoId ? 'contrato' : 'cliente'],
    queryFn: () => (contratoId
      ? api.get(`/contratos/${contratoId}/documentos-cliente`)
      : api.get(`/clientes/${clienteId}/documentos`)).then((r) => r.data.data),
    enabled: !!(contratoId || clienteId),
  });

  if (isLoading) return <div className="text-xs text-gray-400">Carregando documentos…</div>;
  if (!data || !data.length) return <div className="text-xs text-gray-400">Nenhum documento anexado.</div>;

  return (
    <div className="divide-y divide-gray-100 border border-gray-200 rounded-xl overflow-hidden">
      {data.map((d) => (
        <div key={d.id} className="flex items-center gap-3 px-3 py-2 text-sm bg-white">
          <FileText size={15} className="text-gray-400 shrink-0" />
          <span className="shrink-0 text-xs font-medium bg-indigo-50 text-indigo-700 rounded px-2 py-0.5">
            {TIPO_LABEL[d.tipo_doc] || 'Documento'}
          </span>
          <span className="flex-1 truncate text-gray-700">{d.arquivo_nome}</span>
          <span className="text-xs text-gray-400 shrink-0">{fmtBytes(d.tamanho_bytes)}</span>
          <button
            onClick={() => abrir(d.cliente_id || clienteId, d.id, d.arquivo_nome)}
            className="text-blue-600 hover:text-blue-800 shrink-0"
            title="Abrir / baixar"
          >
            <Download size={15} />
          </button>
        </div>
      ))}
    </div>
  );
}
